export default __webpack_public_path__ + "static/280-303d9a499cf68218a316ccebdb10e4fd.gif";